'use client';
import clsx from 'clsx';
import { Button, Image } from '@nextui-org/react';
import { useClientTranslation } from '@/hook/translate';
import { MindfulAudioImg } from '@/config/img/mindfulAudio';
import { useParams } from 'next/navigation';
import Link from 'next/link';
import { mindfulMobileLink } from '@/config/appLink';

export default function AppInstall(props: {
  className?: string;
}) {
  const { t } = useClientTranslation();
  const params = useParams();
  return (
    <div className={clsx('flex items-center flex-col mx-[15px] pt-[30px] pb-[35px] bg-[#F7F8FA] rounded-[10px] mb-[50px]', props?.className)}>
      <div className='booklogo-wrap'>
        <Image alt='bookey' src={MindfulAudioImg.BookeyLogo} width={90} />
      </div>
      {/* <p className={ clsx('text-center text-16-22 pt-1 text-[#155FF9]') }>{ t('downAndUnlock') }</p> */}
      <Image src={`/download-${params.lng || 'en'}-mobile.png`} alt='Download Bookey APP' className='w-full object-fill' />
      <div className='btn-wrap w-full px-9 pt-4'>
        <Link href={mindfulMobileLink.content}>
          <Button radius="sm" className='bg-[#CDF564] w-full h-[49px] font-bold text-14-19'>{t('install')}</Button>
        </Link>
      </div>
    </div>
  );
}

